module.exports = __webpack_public_path__ + "img/chinesecompany118.36b49203.png";